import { ApolloProvider } from '@apollo/client';
import React from 'react';
import baseClient from '@bottlebooks/gatsby-theme-event/src/wrapElement/apolloClient/apolloClient';
import cmsClient from './apolloClient/apolloClientWithCms';

export default function wrapRootElement({ element }) {
  // If Sanity CMS is active, we need to use a composite client
  return process.env.GATSBY_SANITY_PROJECT_ID ? (
    <ApolloProvider client={cmsClient}>{element}</ApolloProvider>
  ) : (
    <ApolloProvider client={baseClient}>{element}</ApolloProvider>
  );
}
